import { last } from 'gleam-shared/helpers/nodash'

export default function extractKey(url) {
  return last(/(?<=\/)[a-zA-Z0-9]{5}(?=[/-]|$)/.exec(url))
}
